import { Stack, Image, ImageFit, Label, PrimaryButton, DefaultButton, FontIcon, IStackTokens, Toggle, ComboBox, IComboBoxOption, IComboBox, TextField, IContextualMenuItem, DetailsList, SelectionMode, DetailsListLayoutMode, ISelection, MarqueeSelection, IconButton, initializeIcons, ConstrainMode } from '@fluentui/react';
import React, { FormEvent } from 'react';
import { TProduct, TSet } from '../constants/types';
import PokemonCards from './cardsComponent';
import Globals, { IsNull } from '../services/Globals';
import styles from '../styles/pokemon.module.scss';
import { NumberLiteralType } from 'typescript';

export interface IclientsProps {
    dev: boolean;
    site: string;
    apiUrl: string;
    username: string;
    token: string;
}

export interface IclientsState {
    clients: any[];
    doneclients: any[];
    allclients: any[];
    selection: ISelection;
    selectedClient: any;
    tt: string;
    cards: any[];
    totalcost: number;
    eurprice: number;
    ammountofcardstotal: number;
};
  

export default class Clients extends React.Component<IclientsProps, IclientsState> {
    constructor(props: IclientsProps) {
        super(props);
        this.GetClients = this.GetClients.bind(this);
        this.addTTandSendMail = this.addTTandSendMail.bind(this);
        this.GetEURPrice = this.GetEURPrice.bind(this);
        this.filterClients = this.filterClients.bind(this);

        this.state = {
            selection: null,
            clients: [],
            doneclients: [],
            allclients: [],
            selectedClient: null,
            tt: "",
            cards: [],
            totalcost: 0,
            eurprice: 1,
            ammountofcardstotal: 0,
        }
        initializeIcons();
        this.GetEURPrice();
        this.GetClients();
    }

    GetEURPrice() {
        fetch(`https://${this.props.site}.nl/Backend?username=${this.props.username}&token=${this.props.token}&site=${this.props.site}`, {
            method: 'GET',
            mode: 'cors',
        }).then((response) => response.json()).then((data) => {
            this.setState({eurprice: data as number});
        });
    }

    private async GetClients() {
        await fetch(`${this.props.apiUrl}/Clients?username=${this.props.username}&token=${this.props.token}&site=${this.props.site}`, {
            method: 'GET',
            mode: 'cors',
        }).then((response) => response.json()).then((data) => { 
            this.filterClients(data);
        }).catch( err => {
            console.log(err);
        });
    }

    private filterClients(data) {
        let clients = [];
        let doneclients = [];
        let allclients = data;
        data.forEach(d => {
            if (d.paid == true) {
                if (d.tt == null || d.tt == undefined || d.tt == "") {
                    clients.push(d);
                } else if (d.delivered == false) {
                    doneclients.push(d);
                }
            }
        });
        this.setState({clients: clients, doneclients: doneclients, allclients: allclients});
        setTimeout(() => {
            const elements = document.getElementsByClassName("ms-DetailsHeader-cellSizer");
            for (let i=0, l=elements.length; i<l; i++) {
                var event = new MouseEvent('dblclick', {
                    'view': window,
                    'bubbles': true,
                    'cancelable': true
                  });
                try {
                elements[i].dispatchEvent(event);
                } catch(err){

                }
            }
        }, 500);
    }

    private clientSelected(item?: any, index?: number, ev?: React.FocusEvent<HTMLElement, Element>) {
        this.setState({tt: item.tt, selectedClient: item, cards: []} );

        let cardids= [];
        let cards = [];
        let totalcost = 6.49;
        let ammountofcardstotal = 0;
        item.cardids.split('|').forEach(cardstr => {
            const cardid = cardstr.split(',')[4];
            const ammount = Number(cardstr.split(',')[3]);
            ammountofcardstotal += ammount;
            if (cardstr.split(',')[0] === "-1") {
                fetch(`${this.props.apiUrl}/Product?productId=${cardid}&username=${this.props.username}&site=${this.props.site}&token=${this.props.token}`, {
                    method: 'GET',
                }).then((response) => response.json()).then((data) => {
                    cards.push({
                        id: data.id,
                        title: data.title,
                        setID: data.setID,
                        priceInEUR: data.priceInEUR,
                        version: "Product",
                        rarity: "Product",
                        available: cardstr.split(',')[3],
                        imageUrls: [`https://pokemoncollectie.nl/assets/Products/${cardid}/${data.imageNames.split(',')[0]}&username=${this.props.username}&token=${this.props.token}`],
                    });
                    cards.sort((a,b)=> a.number < b.number ? -1 : 1);
                    cards.sort((a,b) => a.name < b.name ? -1 : 1);
                    totalcost += (Number(data.priceInEUR)) * ammount;
                    this.setState({cards:cards, totalcost: totalcost});
                });
            } else {
                fetch(`${this.props.apiUrl}/Card?cardid=${cardid}&username=${this.props.username}&site=${this.props.site}&token=${this.props.token}`, {
                    method: 'GET',
                }).then((response) => response.json()).then((data) => { 
                    let card = data as TProduct;
                    if (card.number > 99) {
                        card.scardnumber = `${card.number}`;
                    } else if (card.number > 9) {
                        card.scardnumber = `0${card.number}`;
                    } else {
                        card.scardnumber = `00${card.number}`;
                    }
                    
                    //TODO: move to backend, minimale prijs toevoegen
                    card.priceInUSD = Math.round(card.priceInUSD * 100) /100;
                    card.scost = `${card.cost}`;
                    card.setID = Number(cardstr.split(',')[0]);
                    card.available = cardstr.split(',')[3];
                    let imageUrls: string[] = [];
                    card.imageNames.split(',').forEach(imageName => {
                        imageUrls.push(`https://pokemoncollectie.nl/assets/pokemon/${card.setID}/${card.number.toString()}/${imageName}`);
                    });
                    imageUrls.push(`https://pokemoncollectie.nl/assets/pokemon/cardback.png`);
                    card.imageUrls = imageUrls;
                    cards.push(card);
                    totalcost += card.priceInUSD * ammount * this.state.eurprice;

                    cards.sort((a,b)=> a.number < b.number ? -1 : 1);
                    cards.sort((a,b) => a.name < b.name ? -1 : 1);
                    this.setState({cards:cards, totalcost: totalcost, ammountofcardstotal: ammountofcardstotal});
                }).catch( err => {
                    console.log(err);
                });
            }
        });

        window.scrollTo(0,0);
    }

    private async addTTandSendMail() {
        await fetch(`${this.props.apiUrl}/AddTT?clientid=${this.state.selectedClient.id}&TT=${this.state.tt}&username=${this.props.username}&token=${this.props.token}`, {
            method: 'GET',
        }).then((response) => response.json()).then((data) => { 
            this.GetEURPrice();
            this.GetClients();
            
            alert(data);

            this.setState({
                selection: null,
                clients: [],
                doneclients: [],
                allclients: [],
                selectedClient: null,
                tt: "",
                cards: [],
                totalcost: 0,
                eurprice: 1,
                ammountofcardstotal: 0,
            });
    
            this.GetEURPrice();
            this.GetClients();
        });
    }

    private renderItemColumn = (item: any, index: any, column: any) => {
        let fieldContent = item[column.fieldName];
        switch (column.key) {
            default:
                return <span >{fieldContent}</span>;
        }
    };

    private copyToClipboard(text:string) {
        let clipBoardElem = document.createElement("textarea");
        document.body.appendChild(clipBoardElem);
        clipBoardElem.value = text;
        clipBoardElem.select();
        let successfulCopy = document.execCommand('copy');
        document.body.removeChild(clipBoardElem);
        if (successfulCopy) {
            
        } else {
            alert("Kopieren naar klembord mislukt");
        }
    }

    public render(): React.ReactElement<IclientsProps> {
        console.log(this.state);
        return (   
            <Stack horizontal={false} tokens={{childrenGap:20}} className={styles.aPanel}>
                {this.state.selectedClient ?
                <Stack className={styles.aPanel}>
                    <Stack horizontal tokens={{childrenGap:20}}>

                        <Stack horizontal style={{width:"100%"}}>
                            <Stack>
                                <Stack className={styles.aPanel}>
                                    <Stack horizontal>
                                        {this.state.selectedClient.name.split(' ').map(p => {
                                            return  <div>
                                                        {p}<IconButton  iconProps={{iconName: 'Copy'}} onClick={()=>{this.copyToClipboard(p);}} />
                                                    </div>
                                        })}
                                    </Stack>
                                    <Stack>
                                        <Stack horizontal>
                                            {this.state.selectedClient.postalcode}<IconButton  iconProps={{iconName: 'Copy'}} onClick={()=>{this.copyToClipboard(this.state.selectedClient.postalcode);}} />&nbsp;{this.state.selectedClient.number}<IconButton  iconProps={{iconName: 'Copy'}} onClick={()=>{this.copyToClipboard(this.state.selectedClient.number);}} />
                                        </Stack>
                                        <Stack horizontal>
                                            {this.state.selectedClient.email}<IconButton  iconProps={{iconName: 'Copy'}} onClick={()=>{this.copyToClipboard(this.state.selectedClient.email);}} />
                                        </Stack>
                                    </Stack>
                                </Stack>
                                <Stack horizontal className={styles.aPanel}>
                                    <Label>Bedankt voor uw bestelling. Met vriendelijke groet van Team Pokemoncollectie.nl</Label><IconButton  iconProps={{iconName: 'Copy'}} onClick={()=>{this.copyToClipboard("Bedankt voor uw bestelling. Met vriendelijke groet van Team Pokemoncollectie.nl");}} />
                                </Stack>
                                <Stack horizontal className={styles.aPanel}>
                                    <Label>Aantal : {this.state.ammountofcardstotal}</Label>&nbsp; - &nbsp;
                                    <Label>Totaal : EUR: {this.state.totalcost.toFixed(2).toString()}</Label>&nbsp; - &nbsp;
                                    <Label>Betaald: EUR: {this.state.selectedClient.eur ? this.state.selectedClient.eur : "~ " + this.state.totalcost.toFixed(2).toString()}</Label>&nbsp; - &nbsp;
                                    {this.state.selectedClient.tt ? <a href={`https://jouw.postnl.nl/track-and-trace/${this.state.selectedClient.tt}-NL-${this.state.selectedClient.postalcode}?language=nl`} target='_blank'>TT: {this.state.selectedClient.tt}</a> : "Nog geen TT beschikbaar"}
                                </Stack>
                                <Stack horizontal className={styles.aPanel}>
                                    <TextField  disabled={this.state.selectedClient.tt ? true : false} value={this.state.tt} onChange={(e,v) => this.setState({tt: v})} />
                                    <PrimaryButton disabled={this.state.selectedClient.tt ? true : false} text="Voeg TT toe en stuur mail" onClick={this.addTTandSendMail} />
                                </Stack>
                            </Stack>
                        </Stack>

                    </Stack>
                    <h2>Ordered cards</h2>
                    <Stack horizontal tokens={{childrenGap:20}} wrap>
                        {this.state.cards.map(card => {
                            return <PokemonCards addCard={null} removeCard={null} saving={null} card={card} onBuyClick={undefined} satprice={0} onImageClick={undefined} animationsEnabled={false} eurprice={0} hideSwipe={false} />
                        })}
                    </Stack>
                </Stack>
                : <div></div>}
                <h1>Nieuwe bestellingen</h1>
                <Stack className={styles.aPanel}>
                    <div>
                        {this.state.clients.length < 1 ? <Label>Geen nieuwe bestellingen</Label> :
                        <DetailsList
                            onRenderRow={ (props, defaultRender) => (
                                props.item["paid"] == true ? 
                                <div>
                                    {defaultRender({...props, className: styles.paid})}            
                                </div> :
                                <div>
                                    {defaultRender({...props, className: styles.notpaid})}            
                                </div>
                                ) }
                            items={this.state.clients}
                            selectionMode={SelectionMode.single}
                            isHeaderVisible={true}
                            selection={this.state.selection}
                            selectionPreservedOnEmptyClick={true}
                            onActiveItemChanged={this.clientSelected.bind(this)}
                        />}
                    </div>
                </Stack>
                <Stack className={styles.aPanel}>
                    <h1>Bestellingen onderweg</h1>
                    
                    <DetailsList
                        compact
                        layoutMode={DetailsListLayoutMode.fixedColumns}
                        onRenderItemColumn={this.renderItemColumn}
                        onRenderRow={ (props, defaultRender) => (
                            props.item["paid"] == true ? 
                            <div>
                                {defaultRender({...props, className: styles.paid})}            
                            </div> :
                            <div>
                                {defaultRender({...props, className: styles.notpaid})}            
                            </div>
                            ) }
                        items={this.state.doneclients}
                        selectionMode={SelectionMode.single}
                        isHeaderVisible={true}
                        selection={this.state.selection}
                        selectionPreservedOnEmptyClick={true}
                        onActiveItemChanged={this.clientSelected.bind(this)}
                    />
                    
                </Stack>
                <Stack className={styles.aPanel}>
                    <h1>Bestelgeschiedenis</h1>
                    
                    <DetailsList
                        compact
                        layoutMode={DetailsListLayoutMode.fixedColumns}
                        onRenderItemColumn={this.renderItemColumn}
                        onRenderRow={ (props, defaultRender) => (
                            props.item["paid"] == true ? 
                            <div>
                                {defaultRender({...props, className: styles.paid})}            
                            </div> :
                            <div>
                                {defaultRender({...props, className: styles.notpaid})}            
                            </div>
                            ) }
                        items={this.state.allclients}
                        selectionMode={SelectionMode.single}
                        isHeaderVisible={true}
                        selection={this.state.selection}
                        selectionPreservedOnEmptyClick={true}
                        onActiveItemChanged={this.clientSelected.bind(this)}
                    />
                    
                </Stack>
            </Stack>
        );
    }
}